export const CLOSED_DAY = 'Closed';
export const DAYS_OF_THE_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const FAUX_MIDNIGHT = 1439;
export const NOON = 720;
//# sourceMappingURL=constants.js.map